import React from 'react';
import block from 'bem-cn-lite';
import {HelpTooltip} from '@yandex-data-ui/common';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

import './CalculatorFormLayout.scss';

const b = block('CalculatorFormLayout');

const CalculatorFormLayoutSection: React.FC<ClassNameProps> = ({children, className}) => (
    <div className={b('section', className)}>{children}</div>
);

interface CalculatorFormLayoutRowProps extends ClassNameProps {
    title: string;
    note?: string;
    dataQa?: string;
}

const CalculatorFormLayoutRow: React.FC<CalculatorFormLayoutRowProps> = ({
    title,
    children,
    className,
    note,
    dataQa,
}) => (
    <div className={b('row', className)} data-qa={dataQa}>
        <div className={b('row-left')}>
            <div className={b('row-name')}>
                <div className={b('row-name-text')}>{title}</div>
                {note && (
                    <HelpTooltip
                        className={b('row-note')}
                        htmlContent={note}
                        placement={['bottom', 'right']}
                    />
                )}
            </div>
        </div>
        <div className={b('row-right')}>{children}</div>
    </div>
);

export default class CalculatorFormLayout extends React.Component<ClassNameProps> {
    static Section = CalculatorFormLayoutSection;
    static Row = CalculatorFormLayoutRow;

    render() {
        const {children, className} = this.props;

        return <div className={b(null, className)}>{children}</div>;
    }
}
